import React from 'react';

export default function Linkedin() {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m20.759 3.849-16-.01a1 1 0 0 0-1 .998l-.012 16a1 1 0 0 0 1 1.001l16 .01a1 1 0 0 0 1-.998l.011-16a1 1 0 0 0-1-1.001M9.087 19.178l-2.672-.002.006-8.59 2.672.002zM7.758 9.414a1.548 1.548 0 1 1 .002-3.096 1.548 1.548 0 0 1-.002 3.096m11.329 9.77-2.67-.001.003-4.177c0-.996-.016-2.277-1.386-2.278-1.39-.001-1.602 1.085-1.603 2.206l-.002 4.248-2.668-.002.006-8.59 2.56.002v1.174h.036c.356-.675 1.228-1.386 2.525-1.386 2.704.002 3.202 1.78 3.2 4.095l-.003 4.71z'
        fill='currentColor'
      />
    </svg>
  );
}
